module.exports = __webpack_public_path__ + "static/img/bg-05.821b4f4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zt/bg-05.jpg
// module id = Je75
// module chunks = 1